import { ISetup } from "@smartrr/shared/entities/Organization";
import { GettingStartedStep } from "../GettingStartedStep";

export class CustomerPortalStep extends GettingStartedStep {
  getOrder(): number {
    return 4;
  }

  protected deriveCompleted(setup: ISetup): boolean {
    return !!(
      setup.onSiteSetup?.smartrrSnippets?.completed ||
      setup.onSiteSetup?.customerAccountPortalManualSetup?.completed
    );
  }
}
